import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeBannerpc', function () {
        const el = $(this);
        return {
            swiperOptionOne: {
                initialSlide: 0,
                direction: 'horizontal',
                loop: true,
                autoplay: {
                  delay: 3000,
                  stopOnLastSlide: false,
                  disableOnInteraction: true,
                },
                pagination: {
                  el: '.swiper-pagination-one',
                  renderBullet(index, className) {
                    return `<span class="${className}">
                              <span class="swiper-pagination-bullet-progress"></span>
                            </span>`
                  },
                },
                navigation: {
                  nextEl: '.swiper-button-next-one',
                  prevEl: '.swiper-button-prev-one',
                },
                slidesPerView: 'auto',
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                on: {
                  slideChangeTransitionEnd() {
                    this.autoplay.start()
                  },
                },
            },
            localName: window.Shopify.locale,
            init() {
                /* 页面刷新时执行 */
                window.onload = function () {
                    if (document.body.scrollTop > 0) {
                        window.scrollTo(0, -1)
                        document.body.scrollTop = 0
                    }
                    window.scrollTo(0, -1)
                    document.body.scrollTop = 0
                }
                /* 页面刷新时执行 */
                this.initPC()
            }, // end init
            initPC() {
                this.initPCSwiper()
            },
            initPCSwiper() {
                new Swiper('.swiper-container-banner-pc', this.swiperOptionOne)
            },
        }
    })
}
document.addEventListener('alpine:init', main)